import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'groupbuy_activity',
  components: {
    groupbuyCompanySel: function groupbuyCompanySel() {
      return import('@/views/group_buy/components/company_sel_page.vue');
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '活动',
        addFunName: 'groupBuyActivityAdd',
        modifyFunName: 'groupBuyActivityModify',
        delFunName: 'groupBuyActivityDel',
        queryFunName: 'groupBuyActivityQueryJoinCompanySta',
        detailFunName: 'groupBuyActivityDetail',
        onlineFunName: 'groupBuyActivityOnline',
        unOnlineFunName: 'groupBuyActivityUnOnline',
        indexPushFunName: 'groupBuyActivityIndexPush',
        unIndexPushFunName: 'groupBuyActivityUnIndexPush',
        cacheClearFunName: 'groupBuyActivityCacheClear',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      dicData: {
        upperCode: 'groupbuy_category',
        activityCategorys: [],
        activityCategoryOptions: {},
        activitySecondCategoryOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        firstCategory: null,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        userId: '1512308471658319872',
        companyId: '1512308684926492672',
        name: null,
        subName: null,
        firstCategory: null,
        secondCategory: null,
        beginTime: null,
        endTime: null,
        listImage: null,
        carousel: null,
        carouselArray: [],
        originalCost: null,
        advanceCost: null,
        poster: null,
        music: null,
        details: null,
        shareImg: null,
        unonlineImg: null,
        circulateInventory: null,
        frozenInventory: null,
        browseAmount: null,
        fakeBrowseAmount: null,
        onlineState: false,
        indexPushState: null,
        indexPushSort: null,
        orgLogo: null,
        orgName: null,
        orgRemark: null,
        levelFirstAmount: null,
        levelFirstCost: null,
        levelSecondAmount: null,
        levelSecondCost: null,
        levelThirdAmount: null,
        levelThirdCost: null,
        levelFourthAmount: null,
        levelFourthCost: null,
        levelFifthAmount: null,
        levelFifthCost: null,
        courseExplain: null,
        courseFirst: null,
        courseFirstArray: [],
        courseSecond: null,
        courseSecondArray: [],
        courseThird: null,
        courseThirdArray: [],
        courseFourth: null,
        courseFourthArray: [],
        courseFifth: null,
        courseFifthArray: [],
        companyName: null,
        defaultCollapseOpen: ['activity_info', 'ladder_info'],
        activitySecondeCategorys: []
      },
      tagTemp: '',
      firstCourseInputShow: false,
      secondCourseInputShow: false,
      thirdCourseInputShow: false,
      fourthCourseInputShow: false,
      fifthCourseInputShow: false,
      rules: {
        name: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        companyId: [{
          required: true,
          message: '活动方不能为空',
          trigger: 'blur'
        }],
        firstCategory: [{
          required: true,
          message: '请选择一级分类',
          trigger: 'blur'
        }],
        originalCost: [{
          required: true,
          message: '原价不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '原价必须为有效金额',
          trigger: 'blur'
        }],
        advanceCost: [{
          required: true,
          message: '预付价不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '预付价必须为有效金额',
          trigger: 'blur'
        }],
        fakeBrowseAmount: [{
          pattern: /^[1-9]\d*$/,
          message: '虚拟浏览量必须为正整数',
          trigger: 'blur'
        }],
        circulateInventory: [{
          required: true,
          message: '活动剩余库存不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]\d*$/,
          message: '活动剩余库存必须为 >0 的整数',
          trigger: 'blur'
        }],
        beginTime: [{
          required: true,
          message: '活动开始时间不能为空',
          trigger: 'blur'
        }],
        endTime: [{
          required: true,
          message: '活动开始时间不能为空',
          trigger: 'blur'
        }],
        listImage: [{
          required: true,
          message: '请上传列表图片',
          trigger: 'blur'
        }],
        unonlineImg: [{
          required: true,
          message: '请上传下架图片',
          trigger: 'blur'
        }],
        shareImg: [{
          required: true,
          message: '请上传分享图片',
          trigger: 'blur'
        }],
        poster: [{
          required: true,
          message: '请上传海报图片',
          trigger: 'blur'
        }],
        details: [{
          required: true,
          message: '活动详情不能为空',
          trigger: 'blur'
        }],
        levelFirstAmount: [{
          required: true,
          message: '阶梯一成团人数不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '阶梯一成团人数必须为正整数',
          trigger: 'blur'
        }],
        levelFirstCost: [{
          required: true,
          message: '阶梯一价格不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '阶梯一价格必须为有效金额',
          trigger: 'blur'
        }],
        levelSecondAmount: [{
          pattern: /^[1-9]\d*$/,
          message: '阶梯二成团人数必须为正整数',
          trigger: 'blur'
        }],
        levelSecondCost: [{
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '阶梯二价格必须为有效金额',
          trigger: 'blur'
        }],
        levelThirdAmount: [{
          pattern: /^[1-9]\d*$/,
          message: '阶梯三成团人数必须为正整数',
          trigger: 'blur'
        }],
        levelThirdCost: [{
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '阶梯三价格必须为有效金额',
          trigger: 'blur'
        }],
        levelFourthAmount: [{
          pattern: /^[1-9]\d*$/,
          message: '阶梯四成团人数必须为正整数',
          trigger: 'blur'
        }],
        levelFourthCost: [{
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '阶梯四价格必须为有效金额',
          trigger: 'blur'
        }],
        levelFifthAmount: [{
          pattern: /^[1-9]\d*$/,
          message: '阶梯五成团人数必须为正整数',
          trigger: 'blur'
        }],
        levelFifthCost: [{
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '阶梯五价格必须为有效金额',
          trigger: 'blur'
        }],
        orgName: [{
          required: true,
          message: '机构名称不能为空',
          trigger: 'blur'
        }],
        orgLogo: [{
          required: true,
          message: '请上传机构Logo',
          trigger: 'blur'
        }]
      },
      companySelData: {
        isShow: false
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.upperCode).then(function (res) {
      if (res.data) {
        _this.dicData.activityCategorys = res.data;
        for (var i = 0; i < res.data.length; i++) {
          _this.dicData.activityCategoryOptions[res.data[i].code] = res.data[i].name;
          if (typeof res.data[i].lowerDics !== 'undefined' && res.data[i].lowerDics.length > 0) {
            for (var j = 0; j < res.data[i].lowerDics.length; j++) {
              _this.dicData.activitySecondCategoryOptions[res.data[i].lowerDics[j].code] = res.data[i].lowerDics[j].name;
            }
          }
        }
      }
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'online':
          this.online(command.row);
          break;
        case 'unOnline':
          this.unOnline(command.row);
          break;
        case 'push':
          this.push(command.row);
          break;
        case 'unPush':
          this.unPush(command.row);
          break;
        case 'sort':
          this.sort(command.row);
          break;
        case 'clear':
          this.clear(command.row);
          break;
        case 'del':
          this.del(command.row.id);
          break;
      }
    },
    online: function online(rowData) {
      var _this2 = this;
      this.$confirm('确定上架该活动吗').then(function () {
        _this2.$api[_this2.pageConfig.onlineFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this2.$message.success('上架成功');
            _this2.query();
          } else {
            _this2.$message.error('上架失败');
          }
        });
      });
    },
    unOnline: function unOnline(rowData) {
      var _this3 = this;
      this.$confirm('确定下架该活动吗').then(function () {
        _this3.$api[_this3.pageConfig.unOnlineFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this3.$message.success('下架成功');
            _this3.query();
          } else {
            _this3.$message.error('下架失败');
          }
        });
      });
    },
    push: function push(rowData) {
      var _this4 = this;
      this.$prompt('请输入推荐排序', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          var reg = /^[1-9]\d*$/;
          if (!value || !reg.test(value)) {
            return false;
          }
        },
        inputErrorMessage: '推荐排序错误'
      }).then(function (_ref) {
        var value = _ref.value;
        _this4.$api[_this4.pageConfig.indexPushFunName](rowData.id, value).then(function (res) {
          if (res.data) {
            _this4.$message.success('推荐成功');
            _this4.query();
          } else {
            _this4.$message.error('推荐失败');
          }
        });
      }).catch(function () {});
    },
    sort: function sort(rowData) {
      var _this5 = this;
      this.$prompt('请输入修改的推荐排序', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          var reg = /^[1-9]\d*$/;
          if (!value || !reg.test(value)) {
            return false;
          }
        },
        inputErrorMessage: '推荐排序错误'
      }).then(function (_ref2) {
        var value = _ref2.value;
        _this5.$api[_this5.pageConfig.indexPushFunName](rowData.id, value).then(function (res) {
          if (res.data) {
            _this5.$message.success('推荐排序修改成功');
            _this5.query();
          } else {
            _this5.$message.error('推荐排序修改失败');
          }
        });
      }).catch(function () {});
    },
    unPush: function unPush(rowData) {
      var _this6 = this;
      this.$confirm('确定取消活动首页推荐吗').then(function () {
        _this6.$api[_this6.pageConfig.unIndexPushFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this6.$message.success('取消成功');
            _this6.query();
          } else {
            _this6.$message.error('取消失败');
          }
        });
      });
    },
    clear: function clear(rowData) {
      var _this7 = this;
      this.$confirm('确定刷新活动信息吗').then(function () {
        _this7.$api[_this7.pageConfig.cacheClearFunName](rowData.id).then(function (res) {
          _this7.$message.success('刷新成功');
        });
      });
    },
    changeFormFirstCategory: function changeFormFirstCategory(val) {
      this.formData.secondCategory = null;
      var _iterator = _createForOfIteratorHelper(this.dicData.activityCategorys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.code === val) {
            this.formData.activitySecondeCategorys = item.lowerDics;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.originalCost) {
        paramData.originalCost = (paramData.originalCost / 100).toFixed(2);
      }
      if (paramData.advanceCost) {
        paramData.advanceCost = (paramData.advanceCost / 100).toFixed(2);
      }
      if (paramData.levelFirstCost) {
        paramData.levelFirstCost = (paramData.levelFirstCost / 100).toFixed(2);
      }
      if (paramData.levelSecondCost) {
        paramData.levelSecondCost = (paramData.levelSecondCost / 100).toFixed(2);
      }
      if (paramData.levelThirdCost) {
        paramData.levelThirdCost = (paramData.levelThirdCost / 100).toFixed(2);
      }
      if (paramData.levelFourthCost) {
        paramData.levelFourthCost = (paramData.levelFourthCost / 100).toFixed(2);
      }
      if (paramData.levelFifthCost) {
        paramData.levelFifthCost = (paramData.levelFifthCost / 100).toFixed(2);
      }
      if (paramData.courseFirst) {
        paramData.courseFirstArray = paramData.courseFirst.split(',');
      } else {
        paramData.courseFirstArray = [];
      }
      if (paramData.courseSecond) {
        paramData.courseSecondArray = paramData.courseSecond.split(',');
      } else {
        paramData.courseSecondArray = [];
      }
      if (paramData.courseThird) {
        paramData.courseThirdArray = paramData.courseThird.split(',');
      } else {
        paramData.courseThirdArray = [];
      }
      if (paramData.courseFourth) {
        paramData.courseFourthArray = paramData.courseFourth.split(',');
      } else {
        paramData.courseFourthArray = [];
      }
      if (paramData.courseFifth) {
        paramData.courseFifthArray = paramData.courseFifth.split(',');
      } else {
        paramData.courseFifthArray = [];
      }
      if (paramData.beginTime) {
        paramData.beginTime = paramData.beginTime.toString();
      }
      if (paramData.endTime) {
        paramData.endTime = paramData.endTime.toString();
      }
      if (paramData.carousel) {
        paramData.carouselArray = JSON.parse(paramData.carousel);
      } else {
        paramData.carouselArray = [];
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      if (saveFormData.originalCost) {
        saveFormData.originalCost = parseInt(saveFormData.originalCost * 100);
      }
      if (saveFormData.advanceCost) {
        saveFormData.advanceCost = parseInt(saveFormData.advanceCost * 100);
      }
      if (saveFormData.levelFirstCost) {
        saveFormData.levelFirstCost = parseInt(saveFormData.levelFirstCost * 100);
      }
      if (saveFormData.levelSecondCost) {
        saveFormData.levelSecondCost = parseInt(saveFormData.levelSecondCost * 100);
      }
      if (saveFormData.levelThirdCost) {
        saveFormData.levelThirdCost = parseInt(saveFormData.levelThirdCost * 100);
      }
      if (saveFormData.levelFourthCost) {
        saveFormData.levelFourthCost = parseInt(saveFormData.levelFourthCost * 100);
      }
      if (saveFormData.levelFifthCost) {
        saveFormData.levelFifthCost = parseInt(saveFormData.levelFifthCost * 100);
      }
      if (saveFormData.carouselArray) {
        saveFormData.carousel = JSON.stringify(saveFormData.carouselArray);
      }
      if (saveFormData.courseFirstArray && saveFormData.courseFirstArray.length > 0) {
        saveFormData.courseFirst = saveFormData.courseFirstArray.join(',');
      } else {
        saveFormData.courseFirst = '';
      }
      if (saveFormData.courseSecondArray && saveFormData.courseSecondArray.length > 0) {
        saveFormData.courseSecond = saveFormData.courseSecondArray.join(',');
      } else {
        saveFormData.courseSecond = '';
      }
      if (saveFormData.courseThirdArray && saveFormData.courseThirdArray.length > 0) {
        saveFormData.courseThird = saveFormData.courseThirdArray.join(',');
      } else {
        saveFormData.courseThird = '';
      }
      if (saveFormData.courseFourthArray && saveFormData.courseFourthArray.length > 0) {
        saveFormData.courseFourth = saveFormData.courseFourthArray.join(',');
      } else {
        saveFormData.courseFourth = '';
      }
      if (saveFormData.courseFifthArray && saveFormData.courseFifthArray.length > 0) {
        saveFormData.courseFifth = saveFormData.courseFifthArray.join(',');
      } else {
        saveFormData.courseFifth = '';
      }
      return saveFormData;
    },
    showFirstCourseInput: function showFirstCourseInput() {
      var _this8 = this;
      this.firstCourseInputShow = true;
      this.$nextTick(function (_) {
        _this8.$refs.saveFirstCourseInput.$refs.input.focus();
      });
    },
    handleFirstCourseInputConfirm: function handleFirstCourseInputConfirm() {
      var inputValue = this.tagTemp;
      if (inputValue) {
        this.formData.courseFirstArray.push(inputValue);
      }
      this.firstCourseInputShow = false;
      this.tagTemp = '';
    },
    delFirstCourse: function delFirstCourse(tag) {
      this.formData.courseFirstArray.splice(this.formData.courseFirstArray.indexOf(tag), 1);
    },
    showSecondCourseInput: function showSecondCourseInput() {
      var _this9 = this;
      this.secondCourseInputShow = true;
      this.$nextTick(function (_) {
        _this9.$refs.saveSecondCourseInput.$refs.input.focus();
      });
    },
    handleSecondCourseInputConfirm: function handleSecondCourseInputConfirm() {
      var inputValue = this.tagTemp;
      if (inputValue) {
        this.formData.courseSecondArray.push(inputValue);
      }
      this.secondCourseInputShow = false;
      this.tagTemp = '';
    },
    delSecondCourse: function delSecondCourse(tag) {
      this.formData.courseSecondArray.splice(this.formData.courseSecondArray.indexOf(tag), 1);
    },
    showThirdCourseInput: function showThirdCourseInput() {
      var _this10 = this;
      this.thirdCourseInputShow = true;
      this.$nextTick(function (_) {
        _this10.$refs.saveThirdCourseInput.$refs.input.focus();
      });
    },
    handleThirdCourseInputConfirm: function handleThirdCourseInputConfirm() {
      var inputValue = this.tagTemp;
      if (inputValue) {
        this.formData.courseThirdArray.push(inputValue);
      }
      this.thirdCourseInputShow = false;
      this.tagTemp = '';
    },
    delThirdCourse: function delThirdCourse(tag) {
      this.formData.courseThirdArray.splice(this.formData.courseThirdArray.indexOf(tag), 1);
    },
    showFourthCourseInput: function showFourthCourseInput() {
      var _this11 = this;
      this.fourthCourseInputShow = true;
      this.$nextTick(function (_) {
        _this11.$refs.saveFourthCourseInput.$refs.input.focus();
      });
    },
    handleFourthCourseInputConfirm: function handleFourthCourseInputConfirm() {
      var inputValue = this.tagTemp;
      if (inputValue) {
        this.formData.courseFourthArray.push(inputValue);
      }
      this.fourthCourseInputShow = false;
      this.tagTemp = '';
    },
    delFourthCourse: function delFourthCourse(tag) {
      this.formData.courseFourthArray.splice(this.formData.courseFourthArray.indexOf(tag), 1);
    },
    showFifthCourseInput: function showFifthCourseInput() {
      var _this12 = this;
      this.fifthCourseInputShow = true;
      this.$nextTick(function (_) {
        _this12.$refs.saveFifthCourseInput.$refs.input.focus();
      });
    },
    handleFifthCourseInputConfirm: function handleFifthCourseInputConfirm() {
      var inputValue = this.tagTemp;
      if (inputValue) {
        this.formData.courseFifthArray.push(inputValue);
      }
      this.fifthCourseInputShow = false;
      this.tagTemp = '';
    },
    delFifthCourse: function delFifthCourse(tag) {
      this.formData.courseFifthArray.splice(this.formData.courseFifthArray.indexOf(tag), 1);
    },
    companySel: function companySel(data) {
      if (data) {
        this.formData.companyId = data.id;
        this.formData.companyName = data.name;
      }
      this.companySelData.isShow = false;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    uploadListImage: function uploadListImage(_ref3) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref3.file;
              _this13.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this13.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this13.formData.listImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeListImage: function removeListImage() {
      this.formData.listImage = '';
    },
    uploadUnonlineImg: function uploadUnonlineImg(_ref5) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref5.file;
              _this14.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this14.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this14.formData.unonlineImg = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removeUnonlineImg: function removeUnonlineImg() {
      this.formData.unonlineImg = '';
    },
    uploadShareImg: function uploadShareImg(_ref7) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref7.file;
              _this15.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this15.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this15.formData.shareImg = _context5.sent;
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    removeShareImg: function removeShareImg() {
      this.formData.shareImg = '';
    },
    uploadPoster: function uploadPoster(_ref9) {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref9.file;
              _this16.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this16.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this16.formData.poster = _context7.sent;
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    removePoster: function removePoster() {
      this.formData.poster = '';
    },
    uploadOrgLogo: function uploadOrgLogo(_ref11) {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var file;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              file = _ref11.file;
              _this17.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(res) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return _this17.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this17.formData.orgLogo = _context9.sent;
                      case 3:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x5) {
                  return _ref12.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    removeOrgLogo: function removeOrgLogo() {
      this.formData.orgLogo = '';
    },
    uploadCarousel: function uploadCarousel(_ref13) {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var file;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              file = _ref13.file;
              _this18.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(res) {
                  var filePath;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this18.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        filePath = _context11.sent;
                        _this18.formData.carouselArray.push({
                          uid: file.uid,
                          url: filePath
                        });
                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x6) {
                  return _ref14.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    previewCarouselFile: function previewCarouselFile(file) {
      window.open(file.url);
    },
    removeCarouselFile: function removeCarouselFile(file, fileList) {
      for (var i in this.formData.carouselArray) {
        if (this.formData.carouselArray[i].uid === file.uid) {
          this.formData.carouselArray.splice(i, 1);
        }
      }
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(rowData) {
      var _this19 = this;
      this.$api[this.pageConfig.detailFunName](rowData.id).then(function (res) {
        _this19.initFormData(res.data);
        _this19.formData.defaultCollapseOpen = ['activity_info', 'ladder_info'];
        _this19.formData.companyName = rowData.companyName;
        if (_this19.formData.firstCategory) {
          _this19.changeFormFirstCategory(_this19.formData.firstCategory);
          _this19.formData.secondCategory = res.data.secondCategory;
        }
        _this19.editDialogTitle = _this19.pageConfig.editPageName + '维护';
        _this19.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this20 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this20.$api[_this20.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this20.$message.success('删除成功');
            _this20.query();
          } else {
            _this20.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this21 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this21.tableData = res.data || [];
        _this21.totalCount = res.count;
        _this21.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this22 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this22.formData.id) {
            _this22.$api[_this22.pageConfig.modifyFunName](_this22.saveFormDataProcess(_this22.formData)).then(function (res) {
              if (res.data) {
                _this22.$message.success('编辑成功');
                _this22.initFormData(_this22.emptyFormData);
                _this22.editDialogShow = false;
                _this22.query();
              } else {
                _this22.$message.error('编辑失败');
              }
            });
          } else {
            _this22.$api[_this22.pageConfig.addFunName](_this22.saveFormDataProcess(_this22.formData)).then(function (res) {
              if (res.data) {
                _this22.$message.success('新增成功');
                _this22.initFormData(_this22.emptyFormData);
                _this22.editDialogShow = false;
                _this22.query();
              } else {
                _this22.$message.error('新增失败');
              }
            });
          }
        } else {
          _this22.formData.defaultCollapseOpen = ['activity_info', 'ladder_info', 'org_info'];
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};